
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bangloreinternationalairport() {



    const cardData =
    {
        keyword: '  Bangalore International Airport Corporate Cab Service',
        heading: 'etravo : Bangalore International Airport Corporate Cab Service',



"headingDescription": "eTravo offers reliable Bangalore International Airport Corporate Cab Services, designed for businesses, MNCs, and professionals who require seamless airport transfers, executive pickups, and client transportation. With GPS-enabled vehicles, real-time flight tracking, and experienced chauffeurs, eTravo ensures safe, punctual, and comfortable travel to and from Kempegowda International Airport. Flexible corporate plans make it ideal for frequent business travelers and corporate teams.",

"top": "Top Corporate Cab Service Routes for Bangalore International Airport with eTravo",

"topPlaces": [
  {
    "title": "Kempegowda International Airport (KIA), Devanahalli",
    "description": "Bangalore’s primary international airport handling corporate arrivals and departures with high demand for executive and business travel services."
  },
  {
    "title": "Hebbal Business Hub",
    "description": "A key northern Bangalore business zone providing fast connectivity to the airport, widely used for corporate transfers and executive travel."
  },
  {
    "title": "Yelahanka Industrial & Residential Zone",
    "description": "A major suburban area near the airport with corporate offices and residential communities requiring daily airport commute services."
  },
  {
    "title": "Manyata Tech Park",
    "description": "A major IT hub requiring frequent airport transfers for executives, clients, and international business travelers."
  },
  {
    "title": "Outer Ring Road (ORR) Corridor",
    "description": "A primary corporate belt connecting multiple IT parks to the airport, widely used for business travel and employee mobility."
  },
  {
    "title": "Whitefield IT Hub",
    "description": "A major corporate zone in East Bangalore requiring long-distance airport transfers for IT professionals and MNC executives."
  },
  {
    "title": "Electronic City",
    "description": "A large IT hub in South Bangalore requiring structured airport cab services for corporate employees and business travel."
  },
  {
    "title": "Indiranagar & Domlur",
    "description": "Premium residential and commercial zones with high demand for executive airport transfers and client pickups."
  },
  {
    "title": "MG Road & CBD Area",
    "description": "Central business district of Bangalore with corporate offices requiring reliable airport travel solutions."
  },
  {
    "title": "KR Puram & Marathahalli Corridor",
    "description": "Key transit zones connecting multiple IT hubs to the airport, supporting frequent corporate travel."
  }
],


"services": [
{
"name": "Airport Corporate Cab Bangalore",
"description": "eTravo offers reliable airport corporate cab services in Bangalore designed for smooth and timely transfers. Our service ensures punctual pickups, comfortable rides, and professional chauffeurs for business travelers and executives."
},
{
"name": "Bangalore Airport Taxi Corporate",
"description": "Our corporate airport taxi services in Bangalore provide efficient and hassle-free transportation for companies. eTravo ensures clean vehicles, timely service, and a seamless travel experience to and from the airport."
},
{
"name": "Airport Pickup Corporate Bangalore",
"description": "eTravo provides airport pickup services in Bangalore for corporate clients. Our service ensures on-time arrivals, professional drivers, and comfortable rides for executives and employees."
},
{
"name": "Airport Drop Corporate Bangalore",
"description": "Our airport drop services in Bangalore are designed for stress-free corporate travel. eTravo ensures timely departures with reliable vehicles and experienced chauffeurs."
},
{
"name": "Corporate Airport Transfer Bangalore",
"description": "eTravo offers corporate airport transfer services in Bangalore for seamless travel. Our service ensures smooth coordination, punctual pickups, and comfortable journeys for executives and teams."
},
{
"name": "Business Airport Cab Bangalore",
"description": "Our business airport cab services in Bangalore are ideal for professionals traveling for meetings and corporate purposes. eTravo ensures reliable and comfortable airport transportation."
},
{
"name": "Company Airport Taxi Bangalore",
"description": "eTravo provides company airport taxi services in Bangalore tailored for corporate needs. Our service ensures efficient travel for employees, clients, and executives."
},
{
"name": "Executive Airport Cab Bangalore",
"description": "Experience premium travel with eTravo’s executive airport cab services in Bangalore. Our vehicles provide comfort, privacy, and professional service for senior management and VIP clients."
},
{
"name": "Airport Cab Booking Bangalore",
"description": "eTravo makes airport cab booking in Bangalore simple and convenient. Our service ensures reliable vehicles and timely pickups for all corporate travel needs."
},
{
"name": "Corporate Travel Airport Bangalore",
"description": "eTravo offers corporate travel services for airport transfers in Bangalore. Our service ensures smooth and dependable transportation for business trips and official travel."
},
{
"name": "Staff Airport Pickup Bangalore",
"description": "eTravo provides staff airport pickup services in Bangalore for efficient employee travel. Our service ensures punctual pickups and comfortable rides for workforce mobility."
},
{
"name": "Airport Transfer Services Bangalore",
"description": "Our airport transfer services in Bangalore are designed for seamless and reliable travel. eTravo ensures safe, timely, and comfortable transportation for corporate clients."
},
{
"name": "Office Airport Cab Bangalore",
"description": "eTravo offers office airport cab services in Bangalore for employees traveling for work. Our service ensures convenient and dependable transportation to and from the airport."
},
{
"name": "Professional Airport Taxi Bangalore",
"description": "eTravo provides professional airport taxi services in Bangalore with trained drivers and well-maintained vehicles. Our service ensures safe and comfortable travel for corporate clients."
},
{
"name": "Corporate Airport Commute Bangalore",
"description": "eTravo’s corporate airport commute services in Bangalore provide structured and efficient transportation for business travelers. Our service ensures smooth travel between offices and the airport."
}
],
"tableData": [
["Airport Corporate Cab Bangalore", "Bangalore Airport Taxi Corporate"],
["Airport Pickup Corporate Bangalore", "Airport Drop Corporate Bangalore"],
["Corporate Airport Transfer Bangalore", "Business Airport Cab Bangalore"],
["Company Airport Taxi Bangalore", "Executive Airport Cab Bangalore"],
["Airport Cab Booking Bangalore", "Corporate Travel Airport Bangalore"],
["Staff Airport Pickup Bangalore", "Airport Transfer Services Bangalore"],
["Office Airport Cab Bangalore", "Professional Airport Taxi Bangalore"],
["Corporate Airport Commute Bangalore", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Bangalore International Airport Corporate Cab Service",
      "WhyChoosedescription": "eTravo offers dependable Bangalore International Airport corporate cab services, ensuring smooth and timely transportation for business travelers, executives, and corporate teams."
    },
    {
      "WhyChooseheading": "Seamless Airport Transfers for Corporate Travel",
      "WhyChoosedescription": "Our airport cab services include scheduled pickups, flight tracking, and real-time coordination to ensure hassle-free arrivals and departures for corporate passengers."
    },
    {
      "WhyChooseheading": "Ideal for Executive and VIP Travel",
      "WhyChoosedescription": "Corporate airport cab services are perfect for executives and VIP clients, offering premium vehicles and professional service for a comfortable and impressive travel experience."
    },
    {
      "WhyChooseheading": "Wide Fleet for Airport Transportation",
      "WhyChoosedescription": "We provide hatchbacks, sedans, SUVs, and luxury cars suitable for individual travelers, corporate teams, and business delegations traveling via Bangalore Airport."
    },
    {
      "WhyChooseheading": "Punctual and Time-Sensitive Service",
      "WhyChoosedescription": "With strict adherence to schedules and live flight monitoring, eTravo ensures timely pickups and drop-offs, helping avoid delays and missed flights."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Airport Expertise",
      "WhyChoosedescription": "Our drivers are experienced with Kempegowda International Airport routes and traffic patterns, ensuring efficient and stress-free travel for corporate passengers."
    },
    {
      "WhyChooseheading": "Flexible Corporate Billing and Plans",
      "WhyChoosedescription": "We offer corporate billing, monthly contracts, and GST-compliant invoicing for easy expense management and seamless business operations."
    },
    {
      "WhyChooseheading": "24/7 Availability for Business Travelers",
      "WhyChoosedescription": "Our airport cab services operate round the clock, supporting early morning flights, late-night arrivals, and urgent corporate travel needs."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is Bangalore International Airport corporate cab service?',
            answer: 'It is a professional transportation service providing airport pickup and drop for employees, executives, and corporate clients.',
        },
        {
            question: 'Do airport cab services include flight tracking?',
            answer: 'Yes, most services include real-time flight tracking to adjust pickup timings based on delays or early arrivals.',
        },
        {
            question: 'Which airport is covered under this service?',
            answer: 'Services cover Kempegowda International Airport (BLR) for both domestic and international travel.',
        },
        {
            question: 'Can companies book airport cabs for employees?',
            answer: 'Yes, companies can schedule airport transfers for employees, executives, and business guests.',
        },
        {
            question: 'What types of vehicles are available for airport travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and luxury cars depending on travel requirements.',
        },
        {
            question: 'Are airport cab services available 24/7?',
            answer: 'Yes, services operate round the clock to support all flight schedules.',
        },
        {
            question: 'Do airport cab services provide corporate billing?',
            answer: 'Yes, providers offer GST-compliant invoices and corporate billing options.',
        },
        {
            question: 'Is airport cab service safe for corporate travelers?',
            answer: 'Yes, services include verified drivers, GPS tracking, and safety protocols.',
        },
        {
            question: 'Can airport cab services be customized?',
            answer: 'Yes, travel plans can be customized based on company schedules and requirements.',
        },
        {
            question: 'How can I book Bangalore Airport corporate cab service?',
            answer: 'You can book through the website or contact the support team for quick and customized corporate booking.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Naveen Reddy',
        designation: 'Business Consultant, Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s Bangalore Airport corporate cab service is extremely reliable. Their punctual pickups and smooth coordination make business travel stress-free.”',
    },
    {
        name: 'Ms. Priya Iyer',
        designation: 'HR Manager, IT Company, Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for all our airport transfers. Their professional drivers and timely service ensure a seamless experience for our employees and clients.”',
    },
];




    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bangalore International Airport Corporate Cab Service",
  "image": "https://www.etravo.in/images/keyword/bangalore-airport-corporate-cab.jpg",
  "description": "Reliable corporate cab service for Bangalore International Airport by eTravo. Ideal for airport pickup and drop, executive transfers, business travel, and corporate airport commute with safe, punctual, and professional service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/bangalore-international-airport-corporate-cab-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Bangalore Airport Corporate Cab Service | Pickup & Drop | eTravo</title>
  <meta 
    name="description" 
    content="Book Bangalore International Airport corporate cab service with eTravo for airport pickup and drop, executive travel, business transfers, and corporate airport commute solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/156.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bangloreinternationalairport;